<template>
    <DemoToolsLauncher v-if="isEnabled" title="Onboarding tools" scope="global" />
</template>

<script setup lang="ts">
import type { UserDetails } from "~vue/appTypes";
import DemoToolsLauncher from "~vue/DemoTools/DemoToolsLauncher.vue";
import { computed, inject, type Ref } from "vue";

const userDetails = inject<Ref<UserDetails>>("user_details");
const isEnabled = computed(() => userDetails?.value.calendar_first_onboarding_tools_enabled === true);
</script>
